import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ActivityCategoryForm from '../../../components/forms/ActivityCategoryForm';
import { useActivityCategoryById, useUpdateActivityCategory } from '../../../hooks/useActivityCategoryApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ActivityCategoryDTO } from '../../../services/apiClient';

const ActivityCategoryEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: entityData, isLoading } = useActivityCategoryById(id);
  const updateMutation = useUpdateActivityCategory();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Activity Categories', href: '/admin/activitycategories' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/activitycategories');
    } catch (error) {
      console.error('Error updating Activity Category:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/activitycategories"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ActivityCategory.Edit'
    >
        {entityData ? (
          <ActivityCategoryForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/activitycategories')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default ActivityCategoryEdit;